import {Component} from "@angular/core";
import {Router} from "@angular/router";
import {
  faAddressBook,
  faCogs,
  faUsers,
  faBook,
  faCheckSquare,
  faFile,
  faTools,
  faUserShield
} from "@fortawesome/free-solid-svg-icons";
import {faYoutube} from "@fortawesome/free-brands-svg-icons";

@Component({
  selector: 'app-super-admin-panel',
  templateUrl: './super-admin-panel.component.html',
  styleUrls: ['./super-admin-panel.component.scss']
})
export class SuperAdminPanelComponent {
  readonly accountsIcon = faAddressBook;
  readonly usersIcon = faUsers;
  readonly channelIcon = faYoutube;
  readonly catalogsIcon = faBook;
  readonly orderingIcon = faCheckSquare;
  readonly bannerIcon = faFile;
  readonly manufactureIcon = faTools;
  readonly apexIcon = faUserShield;

  constructor(
    private router: Router
  ) {
  }

  goToAccounts() {
    this.router.navigate(['/sa/accounts']);
  }

  goToUsers() {
    this.router.navigate(['/sa/users']);
  }

  goToChannel() {
    this.router.navigate(['/sa/channel']);
  }

  goToCatalogs() {
    this.router.navigate(['/sa/catalogs']);
  }

  goToOrdering() {
    this.router.navigate(['/sa/ordering']);
  }

  goToBanner() {
    this.router.navigate(['/sa/banner']);
  }

  goToManufacture() {
    this.router.navigate(['/sa/manufacture']);
  }

  goToApex() {
    this.router.navigate(['/sa/apex']);
  }
}
